"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MainHeaderWithBackLink_1 = require("../../../common/components/presentation/MainHeader/MainHeaderWithBackLink");
var ContinueInDealershipText_1 = require("./ContinueInDealershipText");
var ConfirmationMainContent_1 = require("../confirmationMainContent/ConfirmationMainContent");
var ConfirmationContinueInDealerScreen = function () {
    return (<>
      <MainHeaderWithBackLink_1.default titleTranslation={'confirmation.title.dealership'} theme="simple"/>
      <ConfirmationMainContent_1.default>
        <ContinueInDealershipText_1.default />
      </ConfirmationMainContent_1.default>
    </>);
};
exports.default = ConfirmationContinueInDealerScreen;
